module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IGiftCardRedeemedAlertJson extends IAlertJSON {
        minutesMore: number;
    }

    class MeevoEmployeeWorksMoreConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedMinutes: number;

        get selectedMinutesValue() {
            let selectedMinutes = this.selectedMinutes.toString();

            if (!selectedMinutes || isNaN(this.selectedMinutes)) selectedMinutes = 'X';

            return selectedMinutes;
        }

        get dataForReview() {
            return [
                `${this.$translate.instant('LABEL_EMPLOYEE_WORKS_MORE_THAN')} ${this.selectedMinutesValue} ${this.$translate.instant('LABEL_MINUTES_OVER_THEIR_SCHEDULED_TIME')}`
            ];
        }

        get alertConfiguration() {
            return {
                minutesMore: this.selectedMinutes
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: ng.translate.ITranslateService) {
            super(alertsManagerService);

            this.selectedMinutes = 1;
        }

        onEdit(alertJSON: IGiftCardRedeemedAlertJson): void {
            this.selectedMinutes = alertJSON.minutesMore;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoEmployeeWorksMoreConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/employee-works-more-config/employee-works-more-config.component.html',
            controller: MeevoEmployeeWorksMoreConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
